module.exports = __webpack_public_path__ + "static/media/chevron_down.bbcadc8a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/spread/chartOfAccounts/chevron_down.svg
// module id = 2199
// module chunks = 0